import React, {useState, useEffect} from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Chip,
  Skeleton 
} from '@mui/material';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const ActivityButton = ({
  title,
  subtitle,
  clickWrapper,
  check,
  image,
  showScore = true
}) => {

  function handleClick() {
    if (check) return;
    clickWrapper()
  }

  return (
    <Card onClick={handleClick} sx={{ height: '100%', display: 'flex', flexDirection: 'column', padding : 1 }}>
      <CardMedia
        component="div"
        sx={{
          // 16:9
          pt: '56.25%',
          borderRadius: 3
        }}
        image={image}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="h2">
          {title}
        </Typography>
        {showScore && <Chip
          label={subtitle}
          color={check ? 'success' : 'default'} // Cambia el color del chip a verde cuando check es true
          icon={check ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />} // Muestra el ícono de check cuando check es true
        />}
      </CardContent>
    </Card>
  );
};

export default ActivityButton;
